module.exports = __webpack_public_path__ + "static/og-image-b083278235c8e8f4623782e1557f0d49.jpg";